@if (productNames?.length === 1) {
  <div>{{ productNames[0].label }}</div>
} @else {
  <p-select
    placeholder="Select"
    appendTo="body"
    [options]="productNames"
    [(ngModel)]="selectedProduct"
    (onChange)="setActiveProduct($event.value)"
  ></p-select>
}
